import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import type { ActionCodeSettings } from 'firebase/auth'

// ---- Helper: detect your versioned base (/x123) from current path ----
function detectBasePrefix(pathname: string): string {
  // Matches "/x" + digits at the start of the path, e.g. "/x160"
  const m = pathname.match(/^\/x\d+(?=\/|$)/)
  return m ? m[0] : '' // '' if you ever deploy at root
}

// Fill from your Firebase console > Project settings > General > Web app
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
auth.useDeviceLanguage?.()

// Build redirect URL INCLUDING the current versioned base (/x160)
const base = detectBasePrefix(window.location.pathname) // e.g. "/x160"
const redirectUrl = `${window.location.origin}${base}/login` // e.g. "https://eucamd.com/x160/login"

// Where Firebase should send users after they click the email link
export const emailActionSettings: ActionCodeSettings = {
  url: redirectUrl,
  // If you're using true magic links with signInWithEmailLink, set this to true
  // and handle completion in your Login page. If you're ONLY using "email link
  // to set/verify password", you can leave it false. For passwordless, use true.
  handleCodeInApp: true,
  // dynamicLinkDomain: 'link.eucamd.com', // optional if you use Firebase Dynamic Links
}

export const googleProvider = new GoogleAuthProvider()